import React from 'react';
import { Input } from '@/Components/ui/input';
import { Label } from '@/Components/ui/label';
import { Textarea } from '@/Components/ui/textarea';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/Components/ui/select';
import { Globe } from 'lucide-react';
import { cn } from '@/lib/utils';

function FoundingForm({
  organizationType,
  setOrganizationType,
  industryType,
  setIndustryType,
  teamSize,
  setTeamSize,
  yearOfEstablishment,
  setYearOfEstablishment,
  companyWebsite,
  setCompanyWebsite,
  companyVision,
  setCompanyVision,
}) {
  return (
    <form className="flex flex-col gap-4 md:gap-5 w-full">
      {/* First Row - Three columns */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
        <div className="flex flex-col gap-2">
          <Label htmlFor="organization-type" className="text-sm font-semibold">
            Organization Type
          </Label>
          <Select value={organizationType} onValueChange={setOrganizationType}>
            <SelectTrigger id="organization-type" className="h-10">
              <SelectValue placeholder="Select..." />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="startup">Startup</SelectItem>
              <SelectItem value="enterprise">Enterprise</SelectItem>
              <SelectItem value="non-profit">Non-Profit</SelectItem>
              <SelectItem value="Public">Public</SelectItem>
              <SelectItem value="Private">Private</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="flex flex-col gap-2">
          <Label htmlFor="industry-type" className="text-sm font-semibold">
            Industry Types
          </Label>
          <Select value={industryType} onValueChange={setIndustryType}>
            <SelectTrigger id="industry-type" className="h-10">
              <SelectValue placeholder="Select..." />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="technology">Technology</SelectItem>
              <SelectItem value="finance">Finance</SelectItem>
              <SelectItem value="healthcare">Healthcare</SelectItem>
              <SelectItem value="education">Education</SelectItem>
              <SelectItem value="Entertainment">Entertainment</SelectItem>
              <SelectItem value="Automobile">Automobile</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="flex flex-col gap-2">
          <Label htmlFor="team-size" className="text-sm font-semibold">
            Team Size
          </Label>
          <Select value={teamSize} onValueChange={setTeamSize}>
            <SelectTrigger id="team-size" className="h-10">
              <SelectValue placeholder="Select..." />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="1-10">1-10</SelectItem>
              <SelectItem value="11-50">11-50</SelectItem>
              <SelectItem value="51-200">51-200</SelectItem>
              <SelectItem value="201+">201+</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      {/* Second Row - Two columns */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
        <div className="flex flex-col gap-2">
          <Label htmlFor="year-of-establishment" className="text-sm font-semibold">
            Year of Establishment
          </Label>
          <Input
            id="year-of-establishment"
            type="number"
            value={yearOfEstablishment}
            onChange={(e) => setYearOfEstablishment(e.target.value)}
            placeholder="e.g., 2020"
            className="h-10"
          />
        </div>

        <div className="flex flex-col gap-2">
          <Label htmlFor="company-website" className="text-sm font-semibold">
            Company Website
          </Label>
          <div className="relative group/website">
            <Globe className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none z-10 transition-colors group-focus-within/website:text-primary" />
            <Input
              id="company-website"
              type="text"
              value={companyWebsite}
              onChange={(e) => setCompanyWebsite(e.target.value)}
              placeholder="e.g., https://example.com"
              className="!pl-10 !pr-3 !h-10 !py-2 transition-all"
            />
          </div>
        </div>
      </div>

      {/* Vision Field */}
      <div className="flex flex-col gap-2">
        <Label htmlFor="company-vision" className="text-sm font-semibold">
          Company Vision
        </Label>
        <Textarea
          id="company-vision"
          value={companyVision}
          onChange={(e) => setCompanyVision(e.target.value)}
          placeholder="Tell us about your company vision..."
          className="min-h-[120px] resize-none"
        />
      </div>
    </form>
  );
}

export default FoundingForm;
